// @flow
import * as React from "react"
import { css } from "react-emotion/macro"
import { Link } from "react-static"
import { ArrowDown } from "../Icons"
import { hot } from "react-hot-loader"
import { color } from "../../styles/variables"
import { Transition, animated } from "react-spring"
import { setHtml } from "../../utils"

export type tDropdownItem = {
  title: string,
  url: string,
  items?: Array<{
    title: string,
    url: string
  }>
}

export type tDropdown = {
  title: string,
  items: Array<tDropdownItem>
}

export type tDropdownState = {
  active: boolean,
  activeChildToggles: {
    [index: any]: boolean
  }
}

class DropdownInner extends React.Component<tDropdown, tDropdownState> {
  constructor(props: tDropdown) {
    super(props)

    this.state = {
      active: false,
      activeChildToggles: props.items.reduce((acc, child, i) => {
        return {
          ...acc,
          [i]: false
        }
      }, {})
    }
  }
  activate = () => this.setState({ active: true })
  deactivate = () => this.setState({ active: false })
  toggleChild = (index: number) => {
    this.setState((st) => ({
      activeChildToggles: Object.keys(st.activeChildToggles).reduce(
        (acc, key) => {
          const item = st.activeChildToggles[key]
          return {
            ...acc,
            [key]: parseInt(key) === parseInt(index) ? !item : false
          }
        },
        {}
      )
    }))
  }
  render() {
    return this.props.items && this.props.items.length > 0 ? (
      <div
        className={css`
          position: relative;
          margin: 0 25px 0 -15px;
          border-radius: 3px;

          &,
          * {
            transition: all 0.3s ease;
            box-sizing: content-box;
          }

          &::after {
            transition: height 0.3s ease;
            content: "";
            position: absolute;
            width: calc(100%);
            height: 0;
            left: 0;
            top: calc(100% - 4px);
            background: ${color.rgb.purple[1]};
          }

          .dropdown-title,
          .dropdown-list {
            padding: 15px;
            font-size: 15px;
          }

          .dropdown-title {
            font-size: 15px;
            border: none;
            background: rgba(0, 0, 0, 0);
            cursor: pointer;
          }

          .dropdown-list {
            position: absolute;
            top: 100%;
            display: table;
            border-radius: 3px;
            right: 0;
            /* BELOW IS FOR CENTERED DROPDOWN (Nav is now right aligned so sometimes the dropdown will be off-screen if the dropdowns are centered aligned */
            /* transform: translateX(-50%); */
            /* left: 50%; */
            /* right: 0; */

            box-shadow: 0 15px 15px rgba(0, 0, 0, 0.12);
            background: #f7f6f8;
          }

          .dropdown-list-inner {
            position: relative;
            display: table-cell;
          }

          .child-item {
            white-space: nowrap;
            line-height: 2.5;
            padding-left: 15px;
            padding-right: 15px;

            a {
              text-transform: none;
            }
          }

          .child-header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            button {
              background: none;
              border: none;
              padding: 10px 0 10px 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              cursor: pointer;

              &:hover {
                transform: translateY(3px);
              }
            }
          }

          .grandchildren-list {
            padding-left: 15px;
            line-height: 2;
            font-size: 13px;
          }

          ${this.state.active &&
            css`
              &::after {
                height: 4px;
              }
            `};
        `}
        onMouseEnter={this.activate}
        onMouseLeave={this.deactivate}
      >
        <button className="dropdown-title" {...setHtml(this.props.title)} />
        <Transition
          from={{ opacity: 0 }}
          enter={{ opacity: 1 }}
          leave={{ opacity: 0 }}
          config={{ tension: 170, friction: 14, overshootClamping: true }}
        >
          {this.state.active &&
            ((styles) => (
              <animated.div style={styles} className="dropdown-list">
                <div className="dropdown-list-inner">
                  {this.props.items.length > 0 &&
                    this.props.items.map((item, index) => {
                      const hasChildren = item.items && item.items.length > 0
                      const childrenAreActive =
                        hasChildren && this.state.activeChildToggles[index]

                      return (
                        <div key={item.url} className="child-item">
                          <span
                            className={`child-header ${
                              hasChildren ? "has-children" : ""
                            } ${
                              childrenAreActive ? "children-are-active" : ""
                            }`}
                          >
                            <Link
                              className="child-title"
                              to={item.url}
                              {...setHtml(item.title)}
                            />

                            {hasChildren && (
                              <button
                                className="child-items-toggle"
                                onClick={() => this.toggleChild(index)}
                              >
                                <ArrowDown />
                              </button>
                            )}
                          </span>
                          {childrenAreActive && (
                            <ul className="grandchildren-list">
                              {/* $FlowFixMe */}
                              {item.items.map((grandchild, i) => (
                                <li key={grandchild.url + i}>
                                  <Link
                                    to={grandchild.url}
                                    {...setHtml(grandchild.title)}
                                  />
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      )
                    })}
                </div>
              </animated.div>
            ))}
        </Transition>
      </div>
    ) : null
  }
}

export const Dropdown = hot(module)(DropdownInner)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Dropdown/index.js